module.exports = __webpack_public_path__ + "static/media/facilitrain.5b0cf239.jpeg";